import src from "IMAGE";
export default { src, width: 1123, height: 149, blurWidth: 0, blurHeight: 0};
